import React from "react";
import "./Experience.css";

function Experience({ darkMode }) {
    return (
        <section
            className={darkMode ? "Experience-dark" : "Experience"}
            id="experience"
        >
            <h1>Experience</h1>

            <div className="experience-grid">
                {/* O2 Planning & Design */}
                <div className="experience-card">
                    <div className="experience-header">
                        <h2>Software Developer Intern</h2>
                        <span>O2 Planning & Design</span>
                        <p className="duration">Jan 2025 – Apr 2026</p>
                    </div>

                    <p>
                        Developed and optimized software solutions to compile,
                        process, and visualize planning and environmental data,
                        improving workflow efficiency, data accessibility, and
                        analytical capabilities across planning and regional
                        operations.
                    </p>

                    <p>
                        Continued part-time support for development and
                        maintenance, focusing on full-stack implementation,
                        automated data processing, and geospatial analysis using
                        Python-based tools. Contributed to system testing,
                        performance optimization, and integration of security
                        best practices to ensure reliability, scalability, and
                        data integrity.
                    </p>
                </div>

                {/* MASIV */}
                <div className="experience-card">
                    <div className="experience-header">
                        <h2>Software Developer Intern</h2>
                        <span>
                            Mercedes And Singh Innovative Ventures (MASIV)
                        </span>
                        <p className="duration">May 2024 – Nov 2024</p>
                    </div>

                    <p>
                        Developed and implemented software solutions to enhance
                        user interfaces, data management, and operational
                        efficiency. Built a 3D configuration platform with
                        responsive design, improving user engagement by 40%, and
                        created a CRM system enabling secure access to critical
                        company information.
                    </p>

                    <p>
                        Optimized robotic pathing and proximity detection
                        systems, increasing accuracy and reducing task
                        completion time. Worked with React.js, Tailwind CSS,
                        ArcGIS JavaScript API, MongoDB, and AWS S3. Contributed
                        to LLM training, reducing query response times by 50%,
                        alongside system testing, performance tuning, and
                        security enhancements.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default Experience;
